import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dev-device-es",
  "use": "icon-dev-device-es-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-dev-device-es\"><polygon points=\"171.9 61.36 48.1 61.36 36.81 29.44 45.3 26.44 54.46 52.36 165.54 52.36 174.71 26.44 183.19 29.44 171.9 61.36\" /><path d=\"M189.16,196.56H30.84l-1-3.2a83.65,83.65,0,1,1,160.24,0Zm-151.55-9H182.39a74.65,74.65,0,1,0-144.78,0Z\" /><rect x=\"105.5\" y=\"115.16\" width=\"9\" height=\"52.24\" /><rect x=\"105.5\" y=\"56.97\" width=\"9\" height=\"33.18\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol